module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-iphone_2.b4bc552a.png";